import { ToEntity } from 'core/common/mappers';
import { NebulaAccount } from '../entities';
import { NebulaAccountDto } from '../services/dto';

export class NebulaAccountCreationDtoMapper implements ToEntity<NebulaAccount, NebulaAccountDto> {
  toEntity(dto: NebulaAccountDto): NebulaAccount {
    return {
      userId: dto.account.user_id.toString(),
      accountId: dto.account.account_id,
      userType: dto.bucket,
    };
  }
}
